<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><a id="a4"></a><span class="t2">Colin and Martin’s Christmas Collection</span></p>
<p class="p0">4 Stories in 1 Box Set</p>
<p class="p0">By Drew Hunt</p>
<p class="p0">* * * *</p>
<p class="p0"><span class="t6">Table of Contents:</span></p>
<p class="p2"><a id="a5"></a><a href="#/005#a11">Colin and Martin’s First Christmas</a></p>
<p class="p2"><span href="#/006#a12" title="Link target outside of Sample">Colin and Martin’s London Christmas</span></p>
<p class="p2"><span href="#/008#a14" title="Link target outside of Sample">Colin and Martin’s Australian Christmas</span></p>
<p class="p2"><span href="#/009#a15" title="Link target outside of Sample">Colin and Martin’s Goodbye Christmas</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?7acb027a